<script setup lang="ts">
const { open: chatDocked } = useChatDock();
</script>

<template>
  <div :class="['candidate-app flex h-svh min-h-0 flex-col overflow-hidden', { 'chat-docked': chatDocked }]">
    <NonProductionBanner class="shrink-0" />
    <ImpersonationBanner class="shrink-0" />
    <CandidateWriteFailureBanner />
    <div class="min-h-0 flex-1 overflow-auto">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
    <client-only>
      <Toaster expand position="top-right" richColors />
    </client-only>
  </div>
</template>

<style>
/* Keep this width and breakpoint aligned with the chat dock itself. On wide
   screens the live candidate resource reflows beside the open dock; below xl
   the dock is a modal takeover and needs no page inset. */
:root {
  --chat-dock-width: 440px;
}

@media (min-width: 1280px) {
  .candidate-app.chat-docked {
    padding-right: var(--chat-dock-width);
  }
}
</style>
